// src/pages/TrackingMapComponent.jsx
import React from 'react';
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
  LayersControl,
  FeatureGroup
} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const { BaseLayer, Overlay } = LayersControl;

export default function TrackingMapComponent({
  center,
  zoom,
  liveData,
  historyData,
  allowedUsersLocations,
  PopupContent
}) {
  const mapCenter = Array.isArray(center)
    ? center
    : center.latitude && center.longitude
    ? [center.latitude, center.longitude]
    : [50.06, 19.94];

  return (
    <MapContainer center={mapCenter} zoom={zoom} style={{ width: '100%', height: '100%' }}>
      <LayersControl position="topright">
        <BaseLayer checked name="OpenStreetMap">
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="© OpenStreetMap"
          />
        </BaseLayer>
        <BaseLayer name="Satellite">
          <TileLayer
            url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
            attribution="© OpenTopoMap"
          />
        </BaseLayer>

        <Overlay checked name="Live Positions">
          <FeatureGroup>
            {liveData.map(pos => (
              <Marker
                key={`live-${pos.courierId}`}
                position={[pos.latitude, pos.longitude]}
                icon={L.icon({
                  iconUrl: '/marker-icon.png',
                  iconSize: [25, 41],
                  iconAnchor: [12, 41]
                })}
              >
                <Popup>
                  <PopupContent data={pos} />
                </Popup>
              </Marker>
            ))}
          </FeatureGroup>
        </Overlay>

        {historyData && historyData.length > 1 && (
          <Overlay checked name="History Route">
            <FeatureGroup>
              <Polyline
                positions={historyData.map(pt => [pt.latitude, pt.longitude])}
                weight={4}
              />
            </FeatureGroup>
          </Overlay>
        )}

        {Object.entries(allowedUsersLocations).map(([userId, pts]) =>
          pts.length > 0 ? (
            <Overlay key={userId} checked name={`Route ${userId}`}>
              <FeatureGroup>
                <Polyline
                  positions={pts.map(pt => [pt.latitude, pt.longitude])}
                  weight={3}
                  dashArray="5,10"
                />
              </FeatureGroup>
            </Overlay>
          ) : null
        )}
      </LayersControl>
    </MapContainer>
  );
}
